import { Link } from 'react-router-dom';

interface TitleSectionProps {
  title: string;
  viewText: string;
  viewLinkTo: string;
}

export const TitleSection = ({
  title,
  viewText,
  viewLinkTo,
}: TitleSectionProps) => {
  return (
    <div className="flex flex-1 flex-wrap justify-between gap-5">
      <div className="flex flex-1 text-md font-medium">{title}</div>
      <Link to={viewLinkTo} className="text-md font-medium underline">
        {viewText}
      </Link>
    </div>
  );
};
